import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { hasClientAccessToPersonalization } from 'utils/clientSettings';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import useSiteCopySelector from 'components/useSiteCopySelector';

const usePersonalization = () => {
  const [featuresSiteConfig] = useSiteConfigSelector(['Features']);
  const [accountSiteCopy] = useSiteCopySelector(['account']);
  const clientDetails = useSelector(makeSelectClientDetails());

  const isPersonalizationEnabled = hasClientAccessToPersonalization({
    featuresSiteConfig,
    clientDetails,
  });

  const subscriptionOptions = _get(
    accountSiteCopy,
    'pageCopy.subscription',
    [],
  ).filter(item => {
    if (item.value === 'personalization') {
      return isPersonalizationEnabled;
    }

    return true;
  });

  const initialSubscriptionValues = subscriptionOptions
    .filter(item => item.default)
    .map(item => item.value);

  return {
    isPersonalizationEnabled,
    subscriptionOptions,
    initialSubscriptionValues,
  };
};

export default usePersonalization;
